/**
 * Anzeigename einer Fassung. Der Seitentest (test_page) speicherte bis zum
 * 30.09.2026 technische Namen wie „seite-hero_und_abschnitt"; Liste, Detail
 * und Bericht zeigten sie wörtlich, bis ins Urteil („… gewinnt"). Neue Runs
 * tragen schon den lesbaren Namen (seite.ts), alte werden hier übersetzt.
 */

import { t } from './sprache';

const SEITENTEST: Record<string, string> = {
  'seite-hero': 'A/B-Test: neuer Einstieg',
  'seite-hero_und_abschnitt': 'A/B-Test: Einstieg und erster Abschnitt',
  'seite-seite': 'A/B-Test: ganze Seite',
};

const SEITENTEST_EN: Record<string, string> = {
  'seite-hero': 'A/B test: new opening',
  'seite-hero_und_abschnitt': 'A/B test: opening and first section',
  'seite-seite': 'A/B test: whole page',
};

export function fassungsname(variant: string | null | undefined): string {
  if (!variant) return '';
  return t(SEITENTEST, SEITENTEST_EN)[variant] ?? variant;
}

/** Ob der Run aus dem Seitentest stammt (alter oder neuer Name). */
export function istSeitentest(variant: string | null | undefined): boolean {
  if (!variant) return false;
  return variant in SEITENTEST || Object.values(SEITENTEST).includes(variant) || Object.values(SEITENTEST_EN).includes(variant);
}
